import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import rootReducer from './reducers';

import { initialState } from './system/SystemState';

// Configure store using Redux Toolkit
export function configureStore(preloadedState = {}) {
  return configureReduxStore({
    reducer: rootReducer,
    preloadedState,
    // getDefaultMiddleware already includes a dev-only immutability check, so we
    // don't add the standalone redux-immutable-state-invariant on top (that was
    // scanning the whole state twice per dispatch). Both checks below are
    // disabled automatically in production.
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: {
          // The admin and patients slices hold large account/patient lists.
          // The immutability check deep-scans the entire state on every
          // dispatch, so skipping these keeps dev dispatches fast (the admin
          // page was spending tens of ms per dispatch scanning them).
          ignoredPaths: ['admin', 'patients'],
        },
        serializableCheck: {
          // Date objects are intentionally stored in selectedDate throughout the app
          ignoredPaths: ['dailyMetrics.selectedDate', 'active.selectedDate'],
          ignoredActions: ['SELECT_DAILY_METRIC_DATE', 'SELECT_ACTIVE_TEST_DATE'],
        },
      }),
  });
}

export const store = configureStore(initialState);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;

export const useAppThunkDispatch = () => useDispatch<ThunkAppDispatch>();
export const useAppDispatch = () => useDispatch<AppDispatch>();
